export enum PaymentGateway {
	STRIPE = "stripe",
	PAYPAL = "paypal",
	EXTERNAL = "external"
}
